import { render, staticRenderFns } from "./order-title.vue?vue&type=template&id=582b6e5e&scoped=true&"
import script from "./order-title.vue?vue&type=script&lang=js&"
export * from "./order-title.vue?vue&type=script&lang=js&"
import style0 from "./order-title.vue?vue&type=style&index=0&id=582b6e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582b6e5e",
  null
  
)

export default component.exports